"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_emotion_1 = require("react-emotion");
const PageHeader_1 = __importDefault(require("./PageHeader"));
/**
 * Make AWS-UI's Container a real React component
 */
const Container = ({ title, subtitle, description, extraContent, rightJustifiedDescription, buttons, rawButtons, children, footer, withGutters = true, }) => (react_1.default.createElement("div", { className: react_emotion_1.cx('awsui-util-container', withGutters ? '' : 'awsui-util-no-gutters') },
    (title || buttons || rightJustifiedDescription) && (react_1.default.createElement("div", { className: "awsui-util-container-header" },
        react_1.default.createElement(PageHeader_1.default, { title: title, subtitle: subtitle, description: description, rightJustifiedDescription: rightJustifiedDescription, extraContent: extraContent, tag: "h2", buttons: buttons, rawButtons: rawButtons }))),
    children,
    footer && react_1.default.createElement("div", { className: "awsui-util-container-footer" }, footer)));
/**
 * Container with special treatment for legacy bootstrap tables and buttons
 * so that they render like the AWS variants
 */
const LegacyContainer = ({ children, rawButtons, ...props }) => (react_1.default.createElement(Container, Object.assign({ rawButtons: react_1.default.createElement("div", { className: react_emotion_1.css `
          padding: 0.5rem;

          .btn,
          .btn-primary {
            margin-left: 1rem;
          }
        ` }, rawButtons) }, props),
    react_1.default.createElement("div", { className: react_emotion_1.css `
        .table-search {
          padding: 1.5rem 2rem;
          margin: -1.5rem -2rem 1.5rem;
          background: #fafafa;
        }

        .table {
          margin: -1.5rem -2rem;
          width: calc(100% + 4rem);
          max-width: calc(100% + 4rem);
        }

        .table:first-child {
          margin-top: -1.5rem;
        }

        .table:last-child {
          margin-bottom: -2rem;
        }
      ` }, children)));
exports.LegacyContainer = LegacyContainer;
exports.default = Container;
//# sourceMappingURL=Container.js.map